import { ReactNode } from 'react'

import { ClockIcon } from '@heroicons/react/24/outline'
import { FlagIcon } from '@heroicons/react/24/solid'

import { AlertsSummary } from './AlertsSummary.types'

export function AlertsColumnRenderer({ value }: { value: AlertsSummary }) {
  const { days_until_expiration, has_docs_close_to_expire, has_docs_expired } = value || {}

  let icon: undefined | ReactNode
  const showExpiredIcon = has_docs_expired
  const showCloseToExpireIcon = has_docs_close_to_expire && days_until_expiration > 0

  if (showExpiredIcon) {
    icon = (
      <FlagIcon
        color='red'
        className='w-5 h-5'
      />
    )
  } else if (showCloseToExpireIcon) {
    icon = <ClockIcon className='w-5 h-5' />
  } else {
    icon = <div className='text-gray-500'>&mdash;</div>
  }

  return (
    <div
      className='flex items-center justify-center h-full w-full tooltip space-x-1'
      data-for='alerts_summary'
      data-tip
    >
      {icon}
    </div>
  )
}
